<template>
    <div>
        <div class="sub_title">
           주문정보
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">주문일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.orderDate) }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">주문 번호</td>
                    <td>
                        <div class="d_block">
                            {{ orderData.orderNumber }}
                            <el-button class="ml10" size="small" type="warning" @click="openAllOrderCartModal()">전체 주문 확인하기</el-button>
                        </div>
                    </td>
                    <td class="c_t_title">주문 상품 코드</td>
                    <td>
                        <div class="d_block">
                            {{ orderData.orderItemCode }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">주문자 아이디</td>
                    <td>
                        <div class="d_block">
                            <el-link  type="primary" v-if="!checkNo(orderData.memberNo)" @click="moveUser()">{{  orderData.orderPeopleId  }}</el-link>
                            <span v-else>{{  orderData.orderPeopleId }} </span>
                        </div>
                    </td>
                    <td class="c_t_title">주문자 닉네임</td>
                    <td>
                        <div class="d_block">
                            {{ orderData.orderNickname }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">주문자명</td>
                    <td>
                        <div class="d_block">
                            {{ orderData.orderName }}
                        </div>
                    </td>
                    <td class="c_t_title">주문자 전화번호</td>
                    <td>
                        <div class="d_block">
                            {{ phoneFormatter(orderData.orderHp) }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title" rowspan="2">상품이미지</td>
                    <td  rowspan="2">
                        <div class="d_block">
                            <div class="order_img" :style="`background-image:url(${checkImage()})`"></div>
                        </div>
                    </td>
                    <td class="c_t_title">상품명</td>
                    <td>
                        <div class="d_block">
                            <el-link  type="primary" v-if="!checkNo(orderData.itemNo)" @click="moveItem()">{{  orderData.itemName  }}</el-link>
                            <span v-else>{{  orderData.itemName }} </span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">옵션</td>
                    <td>
                        <div class="d_block">
                            {{ returnOption(orderData.itemOption) }}
                        </div>
                    </td>

                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import util from '@/mixins/util';
import numberHyphen from "@/mixins/numberHyphen";
import orderMixins from "@/mixins/orderMixins";
import Vue from "vue";
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);


import dateMixins from "@/mixins/dateMixins";
export default {
    name: "OrderInformationLayout",
    mixins: [dateMixins,numberHyphen,orderMixins],
    components: {
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        orderData: {
            default: () => {
            }, type: Object
        },
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        checkImage(){
            if(!util.isEmpty(this.orderData.itemFiles) && !util.isEmpty(this.orderData.itemFiles[0].a_idx)){
                return this.orderData.itemFiles[0].org_url
            }
        },
        checkNo(data){
            return util.isEmpty(data)
        },
        moveUser(){
           this.$router.push(`/member/${this.orderData.memberNo}`)
        },
        moveItem(){
            this.$router.push(`/item/${this.orderData.itemNo}`)
        },
        openAllOrderCartModal() {
            this.$modal.show('order-information-cart-list-modal', {orderKey: this.orderData.orderKey});
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
